
import Service from "../../AuthService";

const WaitingPayment = {
    getWaitingPayment(page=1){
        return Service.get("/waiting_payment?page="+page);
    },
    searchWaitingPayment(page,data){
        return Service.post("/waiting_payment_search?page="+page,data)
    },
};

export default WaitingPayment
